

function getUrlSearch(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
}

function getLastPath(path) {
  let reg = /.*\/(.*)$/;
  return decodeURIComponent(path.replace(reg, "$1") || null);
}

function queryToSearch(query) {
  let search = '';
  if (query instanceof Object) {
    Object.keys(query).forEach(item => {
      search += item + '=' + query[item] + '&'
    })
  }
  return search.replace(/\&$/, '');

}
function getUrlBase64(name) {
  let url = location.href
  let intercept = url.lastIndexOf('?')
  let res = url.substring(intercept + 1, url.length)
  if (isBase64(res)) {
    let bas64 = decodeURIComponent(atob(res));
    return decodeURIComponent((new RegExp(name + '=' + '([^&;]+?)(&|#|;|$)').exec(bas64) || [, ""])[1].replace(/\+/g, '%20')) || null;
  } else {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null;
  }
}
function isBase64(str) {
  if (str === '' || str.trim() === '') {
    return false;
  }
  try {
    return btoa(atob(str)) == str;
  } catch (err) {
    return false;
  }
}
export default {
  getUrlSearch,
  getLastPath,
  queryToSearch,
  getUrlBase64
}



// WEBPACK FOOTER //
// ./src/libs/utils/GetUrl.js